module.exports = __webpack_public_path__ + "static/media/trash.5866c2c6.svg";